/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable no-console */
import {
  FinishData,
  FinishErrors,
} from "../../common-loader/hooks/useAsyncLoader";
import {
  getLoggedInToken,
  isUserLoggedIn,
  parseCookie,
} from "../../payment/miscellaneous/parseCookie";
import { getCode } from "./getCode";
import { processSignInResponse } from "./processSignInResponse";
import { signIn, SigninResponseProxied } from "./signIn";

export type SignInOutput = Promise<
  FinishData<SigninResponseProxied> | FinishErrors
>;

export async function getToken(tag?: string): Promise<SignInOutput> {
  const loggedIn = isUserLoggedIn(document.cookie);
  const loggedInToken = getLoggedInToken();
  const loginStatus = parseCookie(document.cookie)["MkHcLoggedIn"];

  if (loginStatus === "failed" && tag !== "login-requested") {
    return {
      tag: "errors",
      errors: [],
      uuid: "d54284e7-28b5-4f10-96aa-b09f42fd65e7",
    };
  }

  // When a MkHcLoggedIn is false then MkHcLoggedInToken will be delete
  if (!loggedIn) {
    document.cookie =
      "MkHcLoggedInToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  // When exists a code value is process to get token value.
  // In the case not exists code param on url, the process will based on a MkHcLoggedInToken cookie
  // which take in from request /token when a user click signin.
  if (!!getCode() || !!loggedInToken) {
    const signinResponse = await processSignInResponse();
    if (signinResponse.tag === "data") {
      return {
        tag: "data",
        data: signinResponse.data,
      };
    } else {
      // Check exists a code param on URL then remove code param.
      if (!!getCode()) {
        const currentPath = window.location.pathname.split("?")[0];

        // Remove a code param on the URL.
        window.history.replaceState(null, "", currentPath);
      }

      return {
        tag: "errors",
        errors: [],
        uuid: "d54284e7-28b5-4f10-96aa-b09f42fd65e7",
      };
    }
  } else {
    // Redirect to signin form when not exists a code param url or a MkHcLoggedInToken cookie.
    const signinResponse = await signIn();
    if (signinResponse.tag === "data") {
      return { tag: "data", data: signinResponse.data };
    } else {
      return {
        tag: "errors",
        errors: [],
        uuid: "97c2b7d4-61c4-481f-9a07-79556c014437",
      };
    }
  }
}
